import { render, staticRenderFns } from "./FlowDesigner.vue?vue&type=template&id=2a5a4328&scoped=true"
import script from "./FlowDesigner.vue?vue&type=script&lang=js"
export * from "./FlowDesigner.vue?vue&type=script&lang=js"
import style0 from "./FlowDesigner.vue?vue&type=style&index=0&id=2a5a4328&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5a4328",
  null
  
)

export default component.exports